//wordpress dependencies
import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
//internal dependencies
import Edit from "./edit";
import example from "./example";
import icons from "../../util/RTCLGB-icon-controls/icons"


if (rtcl_block_localize_obj.listing_store_block) {

	registerBlockType("rtcl/listing-store", {
		title: __("Listing Store", "classified-listing"),
		description: __("classified listing store", "classified-listing"),
		category: "classified-list-gb",
		icon: {
			src: icons.rtclLogo,
		},
		keywords: [
			__("listing store", "classified-listing"),
			__("store list", "classified-listing"),
			__("classified-listing", "classified-listing"),
		],
		edit: Edit,
		save: () => null,
		//example,
	});

}